import _slicedToArray from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _PROPERTY_TYPE_ICONS;
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'next-i18next';
import { Title, Wrapper, Features, Feature, SeeAllFeaturesButton, SpaceInfoTitle, SpaceInfoDescription, SpaceInfo, SpaceInfoRight } from './styles';
import Hamburger from '@spa/shared/svg/hamburger';
import { getPropertyRentBy } from '@spa/shared/utils/property';
import { PROPERTY_UNIT_TYPE, SUBUNIT_TYPES } from '@spa/shared/constants/unitTypes';
import { findBedType, isBed } from '@spa/shared/utils/unitTypes';
import { showModalAction } from '@spa/shared/store/actions/modal';
import { modalIds } from '@spa/offer/components/Modals/modal-displayer';
import { RENT_BY_TRANSLATIONS, UNIT_TYPE_TRANSLATIONS, REFERENCE_WITH_GENDER_BY_OFFER_TYPE } from '@spa/shared/constants/translations';
import { getFeatures, transformFeatures } from '@spa/shared/utils/transformers/property';
import { findUnit, getNumberOfBedrooms, translateFromLanguage } from '@spa/shared/utils/transformers';
import { RENT_TYPE } from '@spa/shared/constants/rentType';
import ReadMoreInline from '@spa/shared/components/ReadMoreInline';
import { theme } from '@spa/offer/theme';
import Apartment from '@spa/shared/svg/apartment';
import Studio from '@spa/shared/svg/studio';
import EnergyCertification from '../EnergyCertification';
import { trackAllFeaturesModalOpened } from '@spa/offer/store/actions/tracking';
import SingleBedBedroom from '@spa/shared/svg/single-bed-bedroom';
import DoubleBedBedroom from '@spa/shared/svg/double-bed-bedroom';
import TwinBedBedroom from '@spa/shared/svg/twin-bed-bedroom';
import SharedBedBedroom from '@spa/shared/svg/shared-bed-bedroom';
import House from '@spa/shared/svg/house';
import { Tooltip } from '@spa/shared/index';
import Pill from '@spa/shared/components/Unisystem/Pill';
import Exclamation from '@spa/shared/svg/exclamation';
import { SERVICES_FEATURES } from '@spa/shared/constants/services-features';
import { handleGenderRestrictions } from '@spa/offer/utils/transformers/translations';
export var BED_TYPE_ICONS = {
  'unit-double-bed': __jsx(DoubleBedBedroom, {
    width: 110,
    height: 90
  }),
  'unit-single-bed': __jsx(SingleBedBedroom, {
    width: 94,
    height: 90
  }),
  'unit-twin-bed': __jsx(TwinBedBedroom, {
    width: 110,
    height: 90
  }),
  'subunit-single-bed': __jsx(SharedBedBedroom, {
    width: 110,
    height: 90
  }),
  'subunit-double-bed': __jsx(SharedBedBedroom, {
    width: 110,
    height: 90
  }),
  'subunit-twin-bed': __jsx(SharedBedBedroom, {
    width: 110,
    height: 90
  })
};
export var PROPERTY_TYPE_ICONS = (_PROPERTY_TYPE_ICONS = {}, _defineProperty(_PROPERTY_TYPE_ICONS, PROPERTY_UNIT_TYPE.APARTMENT, __jsx(Apartment, {
  color: theme.colors.blueTeal,
  width: 80,
  height: 80
})), _defineProperty(_PROPERTY_TYPE_ICONS, PROPERTY_UNIT_TYPE.STUDIO, __jsx(Studio, {
  color: theme.colors.blueTeal,
  width: 90,
  height: 90
})), _defineProperty(_PROPERTY_TYPE_ICONS, PROPERTY_UNIT_TYPE.HOUSE, __jsx(House, {
  width: 90,
  height: 90
})), _PROPERTY_TYPE_ICONS);
var YourSpace = function YourSpace(_ref) {
  var _REFERENCE_WITH_GENDE, _REFERENCE_WITH_GENDE2;
  var isRentByProperty = _ref.isRentByProperty,
    propertyDescription = _ref.propertyDescription,
    offerDescription = _ref.offerDescription,
    privateFeatures = _ref.features.privateFeatures,
    propertyFeatures = _ref.propertyFeatures,
    bedType = _ref.bedType,
    rentBy = _ref.rentBy,
    numberOfBeds = _ref.numberOfBeds,
    numberOfBedrooms = _ref.numberOfBedrooms,
    showFeaturesModal = _ref.showFeaturesModal,
    typeCode = _ref.typeCode,
    isChecked = _ref.isChecked,
    offerGenderRestriction = _ref.offerGenderRestriction,
    trackAllFeaturesModalOpenedAction = _ref.trackAllFeaturesModalOpenedAction;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    language = _useTranslation.i18n.language;
  var commonFeatures = isRentByProperty ? _defineProperty({}, typeCode, propertyFeatures) : null;
  var existentFeatures = Object.values((isRentByProperty ? propertyFeatures : privateFeatures) || {}).flat().filter(function (_ref3) {
    var exists = _ref3.exists;
    return exists;
  });
  var filteredExistentFeatures = rentBy === RENT_TYPE.BEDROOM ? existentFeatures : _toConsumableArray(new Set(existentFeatures));
  var genderRestrictions = handleGenderRestrictions(t, offerGenderRestriction, null, true, isRentByProperty);
  var featuresLengthLimit = genderRestrictions.length ? 4 : 5;
  var getDescription = function getDescription() {
    if (isRentByProperty) {
      return propertyDescription !== null && propertyDescription !== void 0 && propertyDescription.length ? propertyDescription : offerDescription;
    }
    return offerDescription !== null && offerDescription !== void 0 && offerDescription.length ? offerDescription : null;
  };
  var context = (_REFERENCE_WITH_GENDE = (_REFERENCE_WITH_GENDE2 = REFERENCE_WITH_GENDER_BY_OFFER_TYPE[!isRentByProperty ? rentBy : typeCode]) === null || _REFERENCE_WITH_GENDE2 === void 0 ? void 0 : _REFERENCE_WITH_GENDE2[language]) !== null && _REFERENCE_WITH_GENDE !== void 0 ? _REFERENCE_WITH_GENDE : {};
  return __jsx(Wrapper, null, __jsx(Title, null, __jsx("h2", null, !isRentByProperty ? t('Your bedroom') : t("Your ".concat(typeCode))), isChecked ? __jsx(Tooltip, {
    zIndex: 99
  }, __jsx(Pill, {
    Icon: Exclamation,
    label: t('Checked'),
    isGreen: true
  }), __jsx("p", null, t('One of our Place Checkers has visited this place, and confirmed its location and authenticity.'))) : null), offerDescription !== null && offerDescription !== void 0 && offerDescription.length || isRentByProperty && propertyDescription !== null && propertyDescription !== void 0 && propertyDescription.length ? __jsx(ReadMoreInline, {
    text: translateFromLanguage(getDescription(), language)
  }) : null, isRentByProperty && __jsx(EnergyCertification, null), __jsx(Features, null, genderRestrictions.map(function (_ref4) {
    var translation = _ref4.translation,
      Icon = _ref4.icon;
    return __jsx(Feature, {
      key: translation
    }, __jsx("div", null, __jsx(Icon, null)), __jsx("div", null, t(translation)));
  }), filteredExistentFeatures.slice(0, featuresLengthLimit).map(function (_ref5) {
    var translation = _ref5.translation,
      translation_old = _ref5.translation_old,
      Component = _ref5.Component,
      area = _ref5.area;
    return __jsx(Feature, {
      key: translation || translation_old
    }, __jsx(Component, null), __jsx("div", null, t(translation || translation_old, {
      area: area
    })));
  })), __jsx(SpaceInfo, null, isRentByProperty ? PROPERTY_TYPE_ICONS[typeCode] : BED_TYPE_ICONS["".concat(rentBy, "-").concat(bedType)], __jsx(SpaceInfoRight, null, __jsx(SpaceInfoTitle, null, t('This is a', {
    context: context
  }), ' ', __jsx("span", null, t(!isRentByProperty ? RENT_BY_TRANSLATIONS[rentBy] : UNIT_TYPE_TRANSLATIONS[typeCode]))), __jsx(SpaceInfoDescription, null, rentBy === RENT_TYPE.BEDROOM ? __jsx(React.Fragment, null, __jsx("p", null, t("You won't have to share the bedroom with anyone else")), __jsx("p", null, t('This room has a total of {{count}} beds available', {
    count: numberOfBeds
  }))) : null, rentBy === RENT_TYPE.BED ? __jsx(React.Fragment, null, __jsx("p", null, t('This is a single bed in a shared bedroom')), __jsx("p", null, t('There are a total of {{count}} beds in this room', {
    count: numberOfBeds
  })), __jsx("p", null, t('As this is a shared bedroom, other beds can be booked by other tenants'))) : null, isRentByProperty ? __jsx("p", null, t('You will have the entire property to yourself')) : null, typeCode !== PROPERTY_UNIT_TYPE.STUDIO ? __jsx("span", null, t('{{count}} rooms in total', {
    count: numberOfBedrooms
  })) : null))), filteredExistentFeatures.length ? __jsx(SeeAllFeaturesButton, {
    isSmall: true,
    isTertiary: true,
    icon: Hamburger,
    iconSide: 'left',
    onClick: function onClick() {
      trackAllFeaturesModalOpenedAction();
      showFeaturesModal({
        privateFeatures: privateFeatures,
        commonFeatures: commonFeatures
      });
    }
  }, t('See all features')) : null);
};
var mapStateToProps = function mapStateToProps(_ref6) {
  var _unit$subunits;
  var _ref6$offer$offerAggr = _ref6.offer.offerAggregate,
    _ref6$offer$offerAggr2 = _ref6$offer$offerAggr.property_aggregate,
    property = _ref6$offer$offerAggr2.property,
    _ref6$offer$offerAggr3 = _ref6$offer$offerAggr2.property,
    propertyDescription = _ref6$offer$offerAggr3.metadata,
    _ref6$offer$offerAggr4 = _ref6$offer$offerAggr3.typology,
    numberOfBedrooms = _ref6$offer$offerAggr4.number_of_bedrooms,
    typeCode = _ref6$offer$offerAggr4.type_code,
    area = _ref6$offer$offerAggr4.area,
    floors = _ref6$offer$offerAggr3.floors,
    propertyFeatures = _ref6$offer$offerAggr3.features,
    verification = _ref6$offer$offerAggr3.verification,
    _ref6$offer$offerAggr5 = _ref6$offer$offerAggr.accommodation_offer,
    _ref6$offer$offerAggr6 = _ref6$offer$offerAggr5.property,
    unitId = _ref6$offer$offerAggr6.unit_id,
    unitType = _ref6$offer$offerAggr6.unit_type,
    offerDescription = _ref6$offer$offerAggr5.description,
    offerGenderRestriction = _ref6$offer$offerAggr5.restrictions.gender;
  var _floors = _slicedToArray(floors, 1),
    units = _floors[0].units;
  var unit = findUnit(units, unitId);
  var beds = unit === null || unit === void 0 ? void 0 : (_unit$subunits = unit.subunits) === null || _unit$subunits === void 0 ? void 0 : _unit$subunits.reduce(function (acc, _ref7) {
    var type_code = _ref7.type_code;
    return isBed(type_code) ? acc + 1 : acc;
  }, 0);
  var rentBy = getPropertyRentBy(property);
  var bedType = findBedType(unitType, units, unit) === SUBUNIT_TYPES.SINGLE_BED && beds === 2 ? SUBUNIT_TYPES.TWIN_BED : findBedType(unitType, units, unit);
  var isChecked = verification === null || verification === void 0 ? void 0 : verification.verified;
  var propertyAreaFeature = _objectSpread(_objectSpread({}, SERVICES_FEATURES.area), {}, {
    area: area !== null && area !== void 0 ? area : 0,
    exists: !!area
  });
  return {
    propertyDescription: propertyDescription,
    offerDescription: offerDescription,
    features: getFeatures(unitId, property),
    propertyFeatures: [propertyAreaFeature].concat(_toConsumableArray(transformFeatures(propertyFeatures))),
    rentBy: rentBy,
    bedType: bedType,
    numberOfBeds: beds,
    numberOfBedrooms: getNumberOfBedrooms(floors, numberOfBedrooms),
    typeCode: typeCode,
    isChecked: isChecked,
    offerGenderRestriction: offerGenderRestriction
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    showFeaturesModal: function showFeaturesModal(features) {
      return dispatch(showModalAction({
        modalId: modalIds.FEATURES,
        features: features
      }));
    },
    trackAllFeaturesModalOpenedAction: function trackAllFeaturesModalOpenedAction() {
      return dispatch(trackAllFeaturesModalOpened());
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(YourSpace);